import { FC, useEffect, useLayoutEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import GlossaryInfoTemplate from '@/components/templates/Glossary/Info';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { client } from '@/lib/microcms';
import { Term } from '@/lib/microcms/model';
import { htmlToTextContent } from '@/lib/microcms/parseHTML';
import { assertIsDefined } from '@/utility/utils';

const GlossaryInfoPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  const { initial, termName } = useParams<{
    initial: string;
    termName: Term['termName'];
  }>();
  assertIsDefined(initial);
  assertIsDefined(termName);

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '/glossary',
      },
      {
        name: initial,
        to: `/glossary/${initial}`,
      },
      {
        name: termName,
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const { data: termData } = useQuery(['glossary', termName], async () =>
    client.getContents('glossary', {
      fields: 'termName,hiragana,description',
      filters: `termName[equals]${termName}`,
      limit: 1,
    }),
  );

  return (
    <>
      <Helmet
        meta={{
          title: `競輪用語集 - ${termName}`,
          description: termData
            ? htmlToTextContent(termData[0].description)
            : '',
        }}
      />
      <GlossaryInfoTemplate
        term={termData ? termData[0] : null}
        termName={termName}
        initial={initial}
      />
    </>
  );
};

export default GlossaryInfoPage;
